import { render, staticRenderFns } from "./KMultiselect.vue?vue&type=template&id=0c16c7d4&"
import script from "./KMultiselect.vue?vue&type=script&lang=js&"
export * from "./KMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports